"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.WafflePanel = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _Button = require("@fluentui/react/lib/Button");

var _Icon = require("@fluentui/react/lib/components/Icon");

var _Panel = require("@fluentui/react/lib/Panel");

var _Utilities = require("@fluentui/react/lib/Utilities");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var styles = require('./WafflePanel.scoped.scss');
/**
 * The WaffleControl is a type of Panel which displays the Waffle Items passed into it.
 * Designed to be used with StandardAppBar, it displays an Office 365 like Waffle Panel.
 */


var WafflePanel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(WafflePanel, _React$Component);

  var _super = (0, _createSuper2.default)(WafflePanel);

  function WafflePanel() {
    (0, _classCallCheck2.default)(this, WafflePanel);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(WafflePanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          items = _this$props.items,
          headerText = _this$props.headerText,
          onDismiss = _this$props.onDismiss,
          panelType = _this$props.panelType;
      var rows = [];

      if (items !== undefined) {
        (0, _forEach.default)(items).call(items, function (item) {
          rows.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.ActionButton, {
            href: item.href,
            target: item.target,
            onClick: item.onClick,
            iconProps: item.iconProps,
            children: item.name
          }, item.key));
        });
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Panel.Panel, {
        headerText: headerText,
        isOpen: isOpen,
        type: panelType,
        onDismiss: onDismiss,
        isLightDismiss: true,
        hasCloseButton: false,
        className: (0, _Utilities.css)(styles.wafflePanel),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.AppBarButton, {
          checked: true,
          primary: true,
          onClick: this.props.onDismiss,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            iconName: 'WaffleOffice365'
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles.waffleBody,
          children: rows
        })]
      });
    }
  }]);
  return WafflePanel;
}(React.Component);

exports.WafflePanel = WafflePanel;